import React from 'react';
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
} from 'react-bootstrap';

const MarketingContent = ({
  marketingTwitter,
  marketingFacebook,
  marketingInstagram,
  marketingQuestion1,
  marketingQuestion2,
  marketingQuestion3,
  openTNCModal,
  handleValue,
  saveMarketingContent,
}) => (
  <div className="payment-info">
    <h4>Get Featured By Cosynd</h4>

    <Row>
      <Col sm={12}>
        <br />
        <p>
          Cosynd features creators on its social media channels and blog. If you
          would like to be considered, please fill out the fields below. By
          completing these fields, you are agreeing to our{' '}
          <a onClick={(e) => openTNCModal(e)}>terms and conditions</a>.
        </p>
        <br />
        <Row>
          <Col md={12} lg={4}>
            <FormGroup>
              <ControlLabel>Your Twitter Handle: </ControlLabel>
              <FormControl
                type="text"
                value={marketingTwitter}
                onChange={(e) => handleValue(e, 'marketingTwitter')}
              />
            </FormGroup>
          </Col>
          <Col md={12} lg={4}>
            <FormGroup>
              <ControlLabel>Your Facebook Handle: </ControlLabel>
              <FormControl
                type="text"
                value={marketingFacebook}
                onChange={(e) => handleValue(e, 'marketingFacebook')}
              />
            </FormGroup>
          </Col>
          <Col md={12} lg={4}>
            <FormGroup>
              <ControlLabel>Your Instagram Handle: </ControlLabel>
              <FormControl
                type="text"
                value={marketingInstagram}
                onChange={(e) => handleValue(e, 'marketingInstagram')}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <ControlLabel>Who or what inspires you? </ControlLabel>
              <FormControl
                componentClass="textarea"
                value={marketingQuestion1}
                onChange={(e) => handleValue(e, 'marketingQuestion1')}
              />
            </FormGroup>
          </Col>
          <Col md={12} lg={12}>
            <FormGroup>
              <ControlLabel>Who is your favorite artist? </ControlLabel>
              <FormControl
                componentClass="textarea"
                value={marketingQuestion2}
                onChange={(e) => handleValue(e, 'marketingQuestion2')}
              />
            </FormGroup>
          </Col>
          <Col md={12} lg={12}>
            <FormGroup>
              <ControlLabel>
                What is the best advice you can give other creators that are
                just starting out?{' '}
              </ControlLabel>
              <FormControl
                componentClass="textarea"
                value={marketingQuestion3}
                onChange={(e) => handleValue(e, 'marketingQuestion3')}
              />
            </FormGroup>
          </Col>
        </Row>
      </Col>
      <Col sm={12}>
        <div className="actions">
          <Button onClick={() => saveMarketingContent()}>Save</Button>
        </div>
      </Col>
    </Row>
  </div>
);

export default MarketingContent;



// WEBPACK FOOTER //
// src/components/Profile/MarketingContent.jsx